var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrypto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    className: "crypto-svg",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0521 2.75H4.9479C4.39536 2.75 3.86546 2.96071 3.47476 3.33579C3.08406 3.71086 2.86456 4.21957 2.86456 4.75V19.25C2.86456 19.7804 3.08406 20.2891 3.47476 20.6642C3.86546 21.0393 4.39536 21.25 4.9479 21.25H20.0521C20.6046 21.25 21.1345 21.0393 21.5252 20.6642C21.9159 20.2891 22.1354 19.7804 22.1354 19.25V4.75C22.1354 4.21957 21.9159 3.71086 21.5252 3.33579C21.1345 2.96071 20.6046 2.75 20.0521 2.75Z",
    stroke: "#6c757d",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01562 21.25L10.8391 15.5735L11.5568 17.1155L13.3667 12.3015L14.275 13.454L15.5849 10.6725L16.1724 11.3875L22.1354 4.566",
    stroke: "#6c757d",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43333 7.041H6.53906",
    stroke: "#6c757d",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43335 7.041V9.464H9.0995C9.80627 9.464 10.3792 8.921 10.3792 8.2525C10.3792 7.584 9.80627 7.0415 9.0995 7.041H7.43335Z",
    stroke: "#6c757d",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43335 9.464V12.0465H9.20939C9.96252 12.0465 10.5735 11.468 10.5729 10.7555C10.5729 10.0425 9.96252 9.4645 9.20887 9.464H7.43335Z",
    stroke: "#6c757d",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43333 12.045H6.53906M7.43125 12.061V12.8555M8.87865 12.061V12.8555M7.43125 6.166V6.961M8.87865 6.166V6.961",
    stroke: "#6c757d",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrypto);
export default __webpack_public_path__ + "static/media/crypto.a826bebeca0f9517e6984e814a6a70ca.svg";
export { ForwardRef as ReactComponent };